import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'documents',
            name: 'document',
            class: 'Modules\\Site\\Entities\\Document'
        }
    }
}